import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { ref, get } from "firebase/database";
import { auth, db } from "./api_firebase";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (!firebaseUser) {
        localStorage.clear();
        sessionStorage.removeItem("InmuebleSeleccionado");
        setUsuario(false);
        setCargando(false);
        return;
      }

      try {
        const correoLimpio = firebaseUser.email.replace(/[@.]/g, "");
        const userIdSnap = await get(ref(db, `/correos/${correoLimpio}`));
        const userId = userIdSnap.val();

        if (!userId) {
          await signOut(auth);
          localStorage.clear();
          setUsuario(false);
          setCargando(false);
          return;
        }

        const userDataSnap = await get(ref(db, `/usuarios/${correoLimpio}/${userId}`));
        const userData = userDataSnap.val();

        if (!userData || userData.estadoregistro !== "AUTORIZADO") {
          await signOut(auth);
          localStorage.clear();
          setUsuario(false);
          setCargando(false);
          return;
        }

        const inmuebleActivo = sessionStorage.getItem("InmuebleSeleccionado");
        const datosInmueble = inmuebleActivo ? JSON.parse(inmuebleActivo) : null;

        localStorage.setItem("EstaLogueado", true);
        localStorage.setItem("NombreCompleto", userData.NombreCompleto || "");
        localStorage.setItem("CorreoElectronico", userData.CorreoElectronico || "");
        localStorage.setItem("Celular", userData.Celular || "");

        if (datosInmueble) {
          localStorage.setItem("Permisos", datosInmueble.permiso || "");
          localStorage.setItem("CodigoCliente", datosInmueble.codigo || "");
          localStorage.setItem("Direccion", datosInmueble.direccion || "");
          localStorage.setItem("RazonSocial", datosInmueble.razonSocial || "");
        } else {
          localStorage.setItem("Permisos", userData.Permisos || "");
          localStorage.setItem("CodigoCliente", userData.CodigoCliente || "");
          localStorage.setItem("Direccion", userData.Direccion || "");
          localStorage.setItem("RazonSocial", userData.RazonSocial || "");
        }

        setUsuario({
          uid: firebaseUser.uid,
          email: firebaseUser.email,
          ...userData,
        });
      } catch {
        await signOut(auth);
        localStorage.clear();
        setUsuario(false);
      }

      setCargando(false);
    });

    return () => unsub();
  }, []);

  return (
    <AuthContext.Provider value={{ usuario, cargando }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
